<script setup lang="ts">
import { onBeforeMount, onMounted, provide, ref } from "vue";
import { appContainer } from "../../../container";
import { CompanyService } from "../../../services/manageCompanyService";
import { CompanyInterface } from "../../../interface/CompanyInterface";
import { useRoute } from "vue-router";
import { StorageKeys, StorageService } from "../../../services/storage.service";
import router from "../../../routes";
import { CompanyQuestionFrozenStatus } from "../../../stores/CompanyQuestionStore";
import { ToastService } from "../../../services/toastService";
import { UserService } from "../../../services/userService";
import { useUserStore } from "../../../stores/UserStore";
import { Roles } from "../../../interface/UserInterface";

const companyService = appContainer.resolve(CompanyService);
const route = useRoute();

const questionStatus = CompanyQuestionFrozenStatus();
const toastService = appContainer.resolve(ToastService);
const userService = appContainer.resolve(UserService);
const userStore = useUserStore();

onBeforeMount(async () => {
  await getCurrentCompany();
  const admin = await getCurrentAdmin();
  userStore.setAdmin(admin);
  token.value = (
    (await storageService.get(StorageKeys.TOKEN)) as any
  ).access_token;
});

onMounted(async () => {
  await questionStatus.getQuestionStatus(Number(route.params.id));
  if (route.name === "ManageEmplyoeeView" || !questionStatus.isFrozen) {
    router.push(`/company/${route.params.id}/description`);
  }
});

async function getCurrentAdmin() {
  return await userService
    .getInvitedUser({
      invited_user: userStore.user?.id,
      invitationType: Roles.Admin,
      companyId: Number(router.currentRoute.value.params.id),
    })
    .then((result) => {
      return result.items[0];
    });
}

const currentCompany = ref<CompanyInterface>();
provide("currentCompany", currentCompany);

const storageService = appContainer.resolve(StorageService);
const token = ref("");

async function getCurrentCompany() {
  return companyService.fetchCompanies().then((result) => {
    currentCompany.value = result.items.find(
      (company) => company.id === Number(route.params.id),
    );
  });
}
async function checkFrozenOnClick() {
  if (questionStatus.isFrozen) {
    return true;
  } else {
    toastService.error("Please Freeze the Questions to Access this Feature");
    return false;
  }
}
</script>

<template>
  <div class="d-flex align-items-center justify-content-between mb-4">
    <div class="breadcrumbs">
      <router-link to="/companies" class="text-decoration-none"
        >Manage Companies</router-link
      >
      / {{ currentCompany?.name }}
    </div>
  </div>

  <ul class="nav nav-pills my-5">
    <li class="nav-item">
      <router-link :to="`/company/${route.params.id}/description`" class="p-2"
        >Introduction</router-link
      >
    </li>

    <li class="nav-item">
      <router-link :to="`/company/${route.params.id}/questions`" class="p-2"
        >Add Questions</router-link
      >
    </li>

    <li
      class="nav-item"
      :class="{ disabled: !questionStatus.isFrozen }"
      @click="checkFrozenOnClick"
    >
      <router-link
        :to="`/company/${route.params.id}/manage-employees`"
        class="p-2"
        >Manage People</router-link
      >
    </li>
    <li class="nav-item">
      <router-link :to="`/company/${route.params.id}/reports`" class="p-2"
        >Reports</router-link
      >
    </li>
  </ul>
  <router-view></router-view>
</template>

<style scoped lang="scss">
@import "../../../theme/variables";
.nav-item {
  a {
    color: #000;
    text-decoration: none;
    border-bottom: 3px solid transparent;
    transition: ease-in 100ms;
    transform-origin: center;
  }
  .router-link-active {
    color: var(--bs-primary);
    border-color: var(--bs-primary);
  }
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;

    a {
      pointer-events: none;
    }
  }
}

.nav-pills {
  row-gap: 16px;
}
// .listing-company {
//   background-color: rgb($blue, 0.2);
// }
</style>
